import React, { useState } from 'react';
import YouTube, { YouTubeProps, YouTubeEvent } from 'react-youtube';

interface YouTubeVideoProps extends YouTubeProps {
  autoplayEnabled?: boolean;
}

export const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
  opts,
  onEnd,
  autoplayEnabled = false,
  ...props
}) => {
  const [videoKey, setVideoKey] = useState(0);
  const [autoplay, setAutoplay] = useState(+autoplayEnabled);

  const handleEnd = (event: YouTubeEvent<number>) => {
    setAutoplay(0);
    setVideoKey(Math.random());
    onEnd?.(event);
  };

  return (
    <YouTube
      key={videoKey}
      opts={{
        ...opts,
        playerVars: { rel: 0, autoplay, modestbranding: 1, ...(opts?.playerVars || {}) },
      }}
      onEnd={handleEnd}
      iframeClassName="embed-responsive"
      {...props}
    />
  );
};
